/**
 * auditUtils.js
 * Central source of truth for audit log type classification.
 * Import EVENT_LOG_TYPES anywhere you need to distinguish events from movements.
 */

export const EVENT_LOG_TYPES = [
    'CREATE',           // New item registered (with initial balance)
    'TERMINAL_LOCK',
    'TERMINAL_UNLOCK',
    'CATALOG',
    'CATALOG_ZONE',
    'CATALOG_DELETE',
    'BULK',
    'BULK_DELETE',
    'BULK_ARCHIVE',
    'DELETE',
    'STRUCTURAL_CHANGE',
    'METADATA_UPDATE',
    'ARCHIVE',
];

/**
 * Returns true if the log entry is a system event (not a stock movement).
 */
export const isEventLog = (log) =>
    EVENT_LOG_TYPES.includes(log.type) ||
    log.product_sku === 'SYSTEM' ||
    Math.abs(log.amount || 0) === 0;
